import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { forkJoin, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService, LanguageService } from 'vhobjects-service/src/services';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'atw-frame-product-by-category-view-more-config',
  templateUrl: './frame-product-by-category-view-more-config.component.html',
  styleUrls: ['./frame-product-by-category-view-more-config.component.scss']
})
export class AtwFrameProductByCategoryViewMoreConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_hieu_ung',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_nut_xem_them',
      index: 4,
    },
  ];
  public optionsBackground = [
    {
      label: 'Hình nền',
      value: 'image',
    },
    {
      label: 'Màu nền',
      value: 'color',
    },
  ];

  fonts = [];
  effect_hover = [];
  customize = [];
  dataAfterChange: any = {};
  openFixedIdCate: boolean = false;
  currentCategory: any;
  tempSearchCategory = ''; // biến trung gian
  searchCategory = '';
  resultSearchCategory = [];
  private searchCategoryChange = new Subject<string>();
  isLoadingSearchCategory = false;
  categories: any[] = []; // biến này lưu danh sách danh mục cho cầu hình hiển thị sản phẩm theo danh mục cố định


  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private languageService: LanguageService,
    private vhAlgorithm: VhAlgorithm,
  ) { }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if(!this.config.hasOwnProperty('fixed_id_category')) {
        this.config.fixed_id_category = 'none';
      }

      forkJoin([
        this.http.get('assets/fonts/fonts.json'),
        this.http.get('assets/data/effects/frame-products.json'),
      ]).subscribe(([fonts, effects]: any) => {
        this.fonts = fonts;
        this.effect_hover = effects;
      });

      // đoạn này để xử lý khi người dùng ngưng gõ 300ms thì mới thực hiện tìm kiếm
      this.searchCategoryChange.pipe(
        debounceTime(300), // thay đổi thời gian chờ ở đây
      ).subscribe(newValue => {
        this.isLoadingSearchCategory = false; // người dùng ngừng gõ
        this.handleSearchCategory(newValue);
      });
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.objectChoosing) {
        this.getCategories();
      }
      if (changes.device) this.device = changes.device.currentValue;
    }
  }

  getCategories() {
    this.vhQueryAutoWeb
      .getCategorys_byFields({}, {})
      .then((rsp: any) => {
        const categories = rsp.data.map((e) => {
          const array_step = [];
          for (let i = 0; i < e.step; i++) {
            array_step.push(i);
          }

          const item = { ...e, array_step };

          if (e._id === this.objectChoosing[`${this.device}_config`].fixed_id_category) {
            this.currentCategory = item;
          }

          return item;
        });

        this.categories = this.vhAlgorithm.sortVietnamesebyASC(categories, 'name_' + this.functionService.selectedLanguageCode);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation(); // ✅ chặn click lan ra ngoài
    this.openFixedIdCate = !this.openFixedIdCate;

    if (this.openFixedIdCate && this.currentCategory?._id !== undefined && this.currentCategory?._id !== 'none') {
      const linkToSearch = this.currentCategory._id;
      setTimeout(() => {
        const selector = `[data-id="${this.currentCategory._id}"]`;
        const targetElement = document.querySelector(selector); 

        if (targetElement) {
          // Thực hiện cuộn
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        } else {
          console.warn(`Không tìm thấy mục với link "${linkToSearch}" trong dropdown.`);
        }
      }, 100);
    }
  }

  trackByPage(index: number, item: any) {
    return item._id;
  }

  /**
   * Chọn danh mục
   * @param cate: mục danh mục sẽ chọn
   */
  chooseCategory(cate) {
    this.openFixedIdCate = false;
    this.config.fixed_id_category = cate === 'none' ? 'none' : cate._id;
    this.currentCategory = cate;

    this.updateConfig();
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * sau khi người dùng ngưng gõ 300ms mới thực hiện hàm này
   */
  private handleSearchCategory(value: string): void {
    const resultSearchCategory = this.searchList(value, JSON.parse(JSON.stringify(this.categories)), ['name_' + this.functionService.selectedLanguageCode]);
    this.resultSearchCategory = this.vhAlgorithm.sortStringbyASC(resultSearchCategory, 'name_' + this.functionService.selectedLanguageCode);
  }

  /**
   * 
   * @param str hàm bỏ dấu tiếng việt
   * @returns 
   */
  private removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * @param data dữ liệu cần tìm kiếm
   * @param field trường cần tìm kiếm
   * @returns 
   */
  private searchList(value: string, data: any[] = [], field: string[]): any[] {
    let result = [];
    value = this.removeAccents(value.toLowerCase());
    for (let item of data) {
      let itemValue = this.removeAccents(item[field[0]].toLowerCase());
      itemValue = this.removeAccents(this.languageService.translate(itemValue).toLowerCase());
      if (itemValue.includes(value)) {
        result.push(item);
      }
    }
    return result;
  }

  /**
   * 
   * @param value giá trị tìm kiếm
   * hàm này thực hiện gọi hàm searchValueChange.next(value) để thực hiện tìm kiếm
   * 
   */
  onSearchCategoryChange(value: string) {
    this.isLoadingSearchCategory = true; // Thiết lập isLoading thành true trước khi gán giá trị cho tempSearchValue
    this.tempSearchCategory = value;
    this.searchCategoryChange.next(value);
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-product-category-view-more']['width'] = event.width + 'px';
    if (event.height) this.class['frame-product-category-view-more']['height'] = event.height + 'px';
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }


  /* -------------------- CÁC HÀM UPDATE DATA LÊN DATABASE -------------------- */

  /**
   * Cập nhật config lên database
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      });
  }

  /**
   * Cập nhật class lên database
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      });
  }

  /**
   * Cập nhật staticdata lên database
   */
  updateStaticdata() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.objectChoosing.staticdata })
      .then((bool: any) => {

      });
  }


  /* ------------------------ CÁC HÀM XỬ LÍ MENU CONFIG ----------------------- */

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

}
